import UnitChip from "@/components/UnitChip"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import populationStore from "../model/population.store"
import { Population } from "../model/population.types"

interface Props {
  onAddClick?: () => void
  onClick?: () => void
  onRemoveClick?: () => void
  population: Population
}

export default function PopulationChip(props: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const activePopulation = useAppSelector(populationStore.selectors.active)
  const selected = useAppSelector(populationStore.selectors.selected)

  //Display active
  //Is selected in the list or is the active element
  const isActive =
    props.population.id === activePopulation.id ||
    (selected.includes(props.population.id) && !activePopulation.EstablishmentId)

  return (
    <UnitChip
      isActive={isActive}
      onAddClick={isActive ? undefined : props.onAddClick}
      onClick={props.onClick ?? (() => dispatch(populationStore.actions.select(props.population.id)))}
      onRemoveClick={isActive ? props.onRemoveClick : undefined}
      unit={{ type: "population", population: props.population }}
    />
  )
}
